export function counter(element: HTMLElement) {
  const target = parseInt(element.dataset.count || "0", 10);
  if (!target) return { destroy() {} };

  // Reduced motion: show the final number without the count-up animation.
  if (typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    element.textContent = String(target);
    return { destroy() {} };
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateCounter(element, target);
          io.unobserve(element);
        }
      });
    },
    { threshold: 0.5 }
  );

  io.observe(element);

  return {
    destroy() {
      io.disconnect();
    }
  };
}

function animateCounter(el: HTMLElement, target: number) {
  const duration = 1500;
  const start = performance.now();

  function tick(now: number) {
    const elapsed = now - start;
    const progress = Math.min(elapsed / duration, 1);
    const eased = 1 - Math.pow(1 - progress, 3);
    el.textContent = String(Math.round(target * eased));
    if (progress < 1) {
      requestAnimationFrame(tick);
    } else {
      el.textContent = String(target);
    }
  }

  requestAnimationFrame(tick);
}
